export const PROPS = {
    config: {},
    domain: {},
    scale: {},
    uniqueValues: {},
    generator: {}
};

